import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { ShowcaseCategoryCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ShowcaseCategoryCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  codeSelectedValue?: { displayId: string; id: string } | null;
  onCodeChange?: (value: string) => void;
  code: string;
  codeError?: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  name: string;
  nameError?: string;
  showcaseCategoryCreateStore: ShowcaseCategoryCreateStore;
};

export const ShowcaseCategoryCreateForm: React.FC<ShowcaseCategoryCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      code = "",
      codeError,
      onCodeChange = () => {},
      name = "",
      nameError,
      onNameChange = () => {},
      showcaseCategoryCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="ShowcaseCategory"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "code":
                    onCodeChange?.(valor);
                    break;
                  case "name":
                    onNameChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={showcaseCategoryCreateStore.getCardErrors("null")}
              title={langStore.groupShowcaseCategoryLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={code}
                  error={Boolean(codeError)}
                  warning={
                    !codeError &&
                    Boolean(showcaseCategoryCreateStore.warnings["code"])
                  }
                  helperText={
                    codeError ||
                    showcaseCategoryCreateStore.warnings["code"]?.message
                  }
                  label={langStore.ShowcaseCategoryCodeLabel}
                  onChange={(value: string) => onCodeChange(value)}
                />

                <InputString
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(showcaseCategoryCreateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    showcaseCategoryCreateStore.warnings["name"]?.message
                  }
                  label={langStore.ShowcaseCategoryNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
